import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['focus', 'scrollable'];
  static values = { scrolled: { type: Boolean, default: false } };

  connect() {
    if (this.hasFocusTarget) {
      const scrollContainer = this.hasScrollableTarget ? this.scrollableTarget : this.element;
      const styles = getComputedStyle(scrollContainer);
      // Consumers (e.g. Percy visual regression) opt out via `--disable-auto-scroll: 1`.
      // Skipping entirely is more deterministic than forcing `behavior: 'instant'`, whose
      // final pixel position drifts with font load / layout timing.
      if (styles.getPropertyValue('--disable-auto-scroll').trim() !== '1') {
        const behavior = styles.scrollBehavior === 'smooth' ? 'smooth' : 'instant';
        this.focusTarget.scrollIntoView({ inline: 'center', block: 'nearest', behavior });
      }
    }
    this.scrolledValue = true;
  }
}
